module.exports = __webpack_public_path__ + "media/assets/defaultThumbnail-ea49ec8bbd94a3b131b0c5a64710088c.svg";